<!--
 * @Author: 忠于自己 429022021@qq.com
 * @Date: 2025-01-18 12:28:02
 * @LastEditors: 忠于自己 429022021@qq.com
 * @LastEditTime: 2025-04-03 15:21:06
 * @FilePath: \duilvpcbase\src\views\originality\children\visaflow\components\d-upload.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="ImageUpload">
    <div class="upload-pic clearfix">
      <div class="upload-pic-item"
           v-for="(item,i) of picArr"
           :key="item">
        <img :src="item"
             alt
             :style="{height,width}" />
        <i class="upload-del"
           @click="delPic(i)"></i>
      </div>
      <div class="upload-file"
           :style="{height,width}">
        <input type="file"
               name="file"
               accept="image/*"
               @change="upload"
               ref="file"
               multiple />
        <img class="file"
             :src="src"
             alt />
      </div>
    </div>
  </div>
</template>

<script>
import "../../../../../html/components/d-upload/d-upload.css"

import { uploadImage } from '../../../../../api/index'

export default {
  name: 'd-visaflow',
  data () {
    return {
      picArr: [],
    };
  },
  props: {
    src: {
      type: String,
    },
    height: {
      type: String,
    },
    width: {
      type: String
    }
  },
  methods: {
    delPic (i) {
      this.picArr.splice(i, 1);
      this.$emit("getPicArr", this.picArr);
    },
    upload (e) {
      let files = e.target.files;
      let that = this;
      for (let i = 0; i < files.length; i++) {
        let reader = new FileReader();
        reader.readAsDataURL(files[i]);
        reader.onload = function (e) {
          uploadImage({
            file: files[i]
          }).then(res => {
            if (res.Type == "Success") {
              that.picArr.push(res.Data);
              that.$emit("getPicArr", that.picArr);
              that.$refs.file.value = null;
              that.$layer.alert(res.Content)
            } else {
              that.$layer.alert(res.Content)
            }
          })

        };
      }
    },
  }
}
</script>